// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IHomeWelcomeGetAllAttrs,
  IHomeWelcomeGetAttrs,
  IHomeWelcomeSaveAttrs,
} from 'interfaces/back-office/content-management/home/welcome/home-welcome-view.interface'

const useWelcome = () => {
  const {
    homeWelcome: {
      homeWelcome_isLoading,
      homeWelcome_isSaveLoading,
      homeWelcome_homeWelcomes,
      homeWelcome_detail,
      homeWelcome_CLEAR_HOME_WELCOMES,
      homeWelcome_CLEAR_HOME_WELCOME,
      homeWelcome_fetchHomeWelcomes: homeWelcomeFetchList,
      homeWelcome_fetchHomeWelcome: homeWelcomeFetch,
      homeWelcome_saveHomeWelcome: homeWelcomeSave,
    },
  } = useStores()

  /**
   * @description Get home welcomes
   *
   * @param {IHomeWelcomeGetAllAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const homeWelcome_fetchHomeWelcomes = useCallback(
    (payload: IHomeWelcomeGetAllAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        homeWelcomeFetchList({
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Get home welcome detail
   *
   * @param {IHomeWelcomeGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const homeWelcome_fetchHomeWelcome = useCallback(
    (payload: IHomeWelcomeGetAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        homeWelcomeFetch({
          params: payload.params,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Save home welcome
   *
   * @param {IHomeWelcomeSaveAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const homeWelcome_saveHomeWelcome = useCallback(
    (payload: IHomeWelcomeSaveAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        homeWelcomeSave({
          params: payload.params,
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    homeWelcome_isLoading,
    homeWelcome_isSaveLoading,
    homeWelcome_homeWelcomes,
    homeWelcome_detail,
    homeWelcome_CLEAR_HOME_WELCOMES,
    homeWelcome_CLEAR_HOME_WELCOME,
    homeWelcome_fetchHomeWelcomes,
    homeWelcome_fetchHomeWelcome,
    homeWelcome_saveHomeWelcome,
  }
}

export { useWelcome }
